import { createFileRoute } from "@tanstack/react-router";
import OrgQuality from "../../../../../../views/content/OrgQuality";

export const Route = createFileRoute("/_authenticated/user/content/quality/category/$category")({
  component: OrgQuality,
  staticData: { application: "Product" },
});
